// extracted by mini-css-extract-plugin
module.exports = {"item":"MenuItem_item__1oFDx"};